 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","Seraa":"Seraa","book":"book","fikria":"fikria","live":"live","muharram":"muharram","news":"news","news_all":"news_all","news_article":"news_article","news_file":"news_file","news_interview":"news_interview","news_literature":"news_literature","news_photo":"news_photo","news_photov2":"news_photov2","news_report":"news_report","news_stories":"news_stories","news_video":"news_video","publications":"publications","DeansAward":"DeansAward","contact":"contact","message_i":"message_i","news_inner":"news_inner","videos":"videos","history":"history","description":"description","structure":"structure","stories_inner":"stories_inner","home":"home"}[chunkId]||chunkId) + "." + {"404":"6310e338","chunk-234162f6":"56c45991","chunk-2cdd48a4":"bd583398","chunk-2da9f6d4":"47b43319","Seraa":"f0bc5a9a","chunk-3dae3ad2":"8006b846","book":"e392407d","fikria":"15230e66","live":"8503f5b6","muharram":"b38e1825","news":"af6ab25f","news_all":"4cc7228e","news_article":"75b663e0","news_file":"8c3eb7fe","news_interview":"6246b32c","news_literature":"08a631b0","news_photo":"cfb3fec0","news_photov2":"c1ae46b7","news_report":"3c72f302","news_stories":"7ceb6851","news_video":"68b0fb5f","publications":"b34fcf3a","chunk-840f10ee":"8a70737a","DeansAward":"5e40c7e7","contact":"5f98b45b","message_i":"7470eeb9","news_inner":"209142be","videos":"eba1c0d1","history":"ff7949d5","description":"b2e9b0b2","structure":"cc602f07","stories_inner":"6b119da8","chunk-27f7b96c":"3da1ee49","home":"075237a6","chunk-0a668140":"cdbd7866","chunk-5dc05e2e":"95fbe68c","chunk-af4046c4":"0524939d","chunk-07360cfb":"ccf28551","chunk-272f1447":"1ca4fd5f","chunk-3e21839e":"5a282ff1","chunk-a650cba6":"ef429981","chunk-4c422265":"a37be466","chunk-9e731f5e":"d8216320","chunk-fe09224a":"20cd33ec","chunk-eb1d9fe0":"ea75cfea","chunk-ef9c892c":"eab15b23","chunk-39e3353b":"b8278f59","chunk-3f337211":"fd63e7e1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-234162f6":1,"chunk-2cdd48a4":1,"chunk-2da9f6d4":1,"Seraa":1,"chunk-3dae3ad2":1,"book":1,"fikria":1,"live":1,"muharram":1,"news":1,"news_all":1,"news_article":1,"news_file":1,"news_interview":1,"news_literature":1,"news_photo":1,"news_photov2":1,"news_report":1,"news_stories":1,"news_video":1,"publications":1,"chunk-840f10ee":1,"DeansAward":1,"contact":1,"message_i":1,"news_inner":1,"videos":1,"history":1,"description":1,"structure":1,"stories_inner":1,"chunk-27f7b96c":1,"chunk-0a668140":1,"chunk-5dc05e2e":1,"chunk-af4046c4":1,"chunk-07360cfb":1,"chunk-272f1447":1,"chunk-3e21839e":1,"chunk-a650cba6":1,"chunk-4c422265":1,"chunk-9e731f5e":1,"chunk-fe09224a":1,"chunk-eb1d9fe0":1,"chunk-ef9c892c":1,"chunk-39e3353b":1,"chunk-3f337211":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","Seraa":"Seraa","book":"book","fikria":"fikria","live":"live","muharram":"muharram","news":"news","news_all":"news_all","news_article":"news_article","news_file":"news_file","news_interview":"news_interview","news_literature":"news_literature","news_photo":"news_photo","news_photov2":"news_photov2","news_report":"news_report","news_stories":"news_stories","news_video":"news_video","publications":"publications","DeansAward":"DeansAward","contact":"contact","message_i":"message_i","news_inner":"news_inner","videos":"videos","history":"history","description":"description","structure":"structure","stories_inner":"stories_inner","home":"home"}[chunkId]||chunkId) + "." + {"404":"31d6cfe0","chunk-234162f6":"3267bb83","chunk-2cdd48a4":"a73aec60","chunk-2da9f6d4":"1a31b591","Seraa":"2295c395","chunk-3dae3ad2":"6be7f72d","book":"f3792bbe","fikria":"a9e3bf4e","live":"dc549aa8","muharram":"f0bb145b","news":"bb86e3d7","news_all":"e27323a4","news_article":"5a408bd9","news_file":"5a408bd9","news_interview":"5a408bd9","news_literature":"4f5cce11","news_photo":"a62e0e91","news_photov2":"b59a1bea","news_report":"5a408bd9","news_stories":"bad77764","news_video":"5a408bd9","publications":"29021fea","chunk-840f10ee":"65e4acd1","DeansAward":"5179d640","contact":"904a1c3c","message_i":"9e5cff02","news_inner":"468e182c","videos":"efe1b84c","history":"478b71d5","description":"589818a3","structure":"607eaeec","stories_inner":"18bca7af","chunk-27f7b96c":"e287307a","home":"31d6cfe0","chunk-0a668140":"53256347","chunk-5dc05e2e":"29abd48e","chunk-af4046c4":"dcf7d610","chunk-07360cfb":"3aa8229d","chunk-272f1447":"9196ef73","chunk-3e21839e":"ab1e9023","chunk-a650cba6":"b126b70c","chunk-4c422265":"be305a38","chunk-9e731f5e":"19ab70f4","chunk-fe09224a":"ea4497d0","chunk-eb1d9fe0":"5814a5aa","chunk-ef9c892c":"0e008578","chunk-39e3353b":"793dedab","chunk-3f337211":"7840c79a"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
